<template>
    <div id="app">
        <whiteboard></whiteboard>
    </div>
</template>

<script>
    import Whiteboard from "./components/WhiteBoard.vue";

    export default {
        name: 'App',
        components: {
            Whiteboard
        }
    }
</script>

<style>
    body {
        margin: 0;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>
